<template>
  <v-card flat>
    <v-overlay v-if="deleting" absolute :opacity="0.7">
      <div class="text-center">
        <v-progress-circular :size="30" indeterminate></v-progress-circular>
        <div class="caption mt-4">Deleting File</div>
      </div>
    </v-overlay>

    <v-card-text v-if="tab.description" class="grey lighten-4">
      <p>{{tab.description}}</p>
    </v-card-text>
    <v-divider v-if=" tab.description"></v-divider>

    <section v-if="!tab.files.length">
      <v-container>
        <v-row align="center">
          <v-col cols="12" class="py-12 text-center">
            <h4 class="text--secondary">
              No documents available
              <v-icon>fa-frown</v-icon>
            </h4>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <section>
      <v-container class="pa-0">
        <v-row>
          <v-col cols="12" class="py-0">
            <v-list two-line subheader class="scroll-box py-0">
              <template v-for="(item,i) in tab.files">
                <v-list-item :key="`document-${i}`" :href="item.url" target="_blank">
                  <v-list-item-avatar>
                    <v-icon>{{fileIcon(item.name)}}</v-icon>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title v-text="item.name"></v-list-item-title>
                    <v-list-item-subtitle>{{(item.size/1000).toFixed(1)}}kb</v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action @click="removeItem(item,$event)" v-if="!readonly">
                    <v-btn icon>
                      <v-icon>fa-times</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
                <v-divider :key="`document-divider-${i}`"></v-divider>
              </template>
            </v-list>
          </v-col>
        </v-row>
      </v-container>
    </section>
  </v-card>
</template>

<script>
export default {
  name: "PortalSectionDocumentTab",
  props: ["value", "readonly"],
  data() {
    return {
      deleting: false,
      slide: ""
    };
  },
  components: {},
  computed: {
    tab() {
      return this.value;
    }
  },
  methods: {
    async removeItem(v, ev) {
      ev.preventDefault();
      if (!confirm("Sure you want to remove that item ?")) {
        return;
      }
      this.deleting = true;
      try {
        await this.$api.delete(`/user/portals/delete-upload`, {
          data: v
        });
        this.tab.files = this.tab.files.filter(item => {
          return item !== v;
        });
        this.$emit("change");
      } catch (ex) {
        alert(ex.error);
      }
      this.deleting = false;
    },
    fileIcon(name) {
      if (name.endsWith(".pdf")) {
        return "fa-file-pdf";
      }
      if (name.endsWith(".doc")) {
        return "fa-file-word";
      }
      if (name.endsWith(".docx")) {
        return "fa-file-word";
      }
      if (name.endsWith(".ppt")) {
        return "fa-file-powerpoint";
      }
      if (name.endsWith(".csv") || name.endsWith(".xls")) {
        return "fa-file-excel";
      }

      return "fa-file-alt";
    }
  }
};
</script>

<style scoped lang="scss">
.sheetbox {
  align-items: center;
  justify-content: center;
  display: flex;
}
.item-delete {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 201;
}
</style>